function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import _ from "lodash";
import HyperFormulaBuilder from "./../../components/hyperformula/builder";
import ReactFormulaAgGridTable from "./ag-grid-table";
import { Button, Col, Row, Container } from "react-bootstrap";

var ReactFormulaField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactFormulaField, _React$Component);

  function ReactFormulaField(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (values) {
      var onChange = _this.props.onChange;
      onChange && onChange(values);
    });

    _this.builder = new HyperFormulaBuilder();
    _this.state = {
      headers: []
    };
    return _this;
  }

  var _proto = ReactFormulaField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var headers = this.getHeaders(this.props);
    this.builder.withHeaders(headers);
    this.setState({
      headers: headers
    });
  };

  _proto.getHeaders = function getHeaders() {
    var _this2 = this;

    var properties = _.get(this.props, "schema.items.properties", {});

    var headers = _.toPairs(properties);

    return _.map(headers, function (_ref) {
      var headerKey = _ref[0],
          headerObject = _ref[1];

      var header = _extends({
        header: headerKey
      }, headerObject);

      if (header.readOnly) {
        var formula = _.get(_this2.props, "uiSchema.ui:options.formulas." + headerKey, "");

        header.formula = formula;
      }

      return header;
    });
  };

  _proto.render = function render() {
    this.builder.withDataObjects(this.props.formData);

    var label = _.get(this.props, "schema.title", "");

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, label)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, this.builder && /*#__PURE__*/React.createElement(ReactFormulaAgGridTable, {
      builder: this.builder,
      headers: this.state.headers,
      value: this.props.formData,
      onChange: this.handleChange,
      confirmRemove: this.props.uiSchema["ui:options"].confirmRemove || false,
      removable: this.props.uiSchema["ui:options"].removable === undefined ? true : this.props.uiSchema["ui:options"].removable,
      height: this.props.uiSchema["ui:options"].height,
      width: this.props.uiSchema["ui:options"].width
    }))));
  };

  return ReactFormulaField;
}(React.Component);

export default ReactFormulaField;